import React, { useState, useEffect } from "react";
import "./Checkout.css";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import Order_summery_holder from "../cart/order_summery_holder/Order_summery_holder";
import Success_Modal from "../common-components/common-modals/success_modal/Success_Modal";
import { useNavigate } from "react-router-dom";
import New_Address_Modal from "../common-components/common-modals/new_address_modal/New_Address_Modal";
import Logout_Modal from "../common-components/common-modals/logout_modal/Logout_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrder,
  deleteAddress,
  getAllOrderAddress,
  getRazorpayKey, 
  PaymentOnline,
} from "../../features/order/orderSlice";
import { OrderCalculation } from "../../features/order/orderSlice";
import { getAllCart } from "../../features/cart/cartSlice";
import useRazorpay from "react-razorpay";
import Edit_Address_Modal from "../common-components/common-modals/new_address_modal/Edit_Address_Modal";
import Common_Back_Header from "../common-components/common_back_header/Common_Back_Header";

// Reusable popup + the existing policy pages
import Policy_Modal from "../common-components/policy_modal/Policy_Modal";
import Terms_Conditions from "../terms_conditions/Terms_Conditions";
import Privacy_Policy from "../privacy_policy/Privacy_Policy";

const Checkout = () => {
  const [successmodal, setSuccessmodal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showEditAddressModal, setShowEditAddressModal] = useState(false);
  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const [GSTNumber, setGSTNumber] = useState("");
  // Terms & Conditions consent (Pay Now is blocked until this is ticked)
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsError, setTermsError] = useState("");
  // Which policy popup is open -> null | "terms" | "privacy"
  const [policyModal, setPolicyModal] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useDispatch();
  const [deleteModal, setDeletemodal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [CouponData, setCouponData] = useState("");
  const [rewardData, setRewardData] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState(2);
  const [editId, setEditId] = useState();
  const orderSumary = useSelector((state) => state.order.orderCalculation);
  const allOrdersAddress = useSelector((state) => state.order.allOrdersAddress);

  useEffect(() => {
    dispatch(getAllOrderAddress());
  }, [dispatch]);

  useEffect(() => {
    if (allOrdersAddress && allOrdersAddress?.data?.length > 0) {
     
      setSelectedAddress((prev) => {
        const stillExists = allOrdersAddress.data.some(
          (a) => a?.id === prev,
        );
        return stillExists ? prev : allOrdersAddress.data[0]?.id;
      });
    } else {
      setSelectedAddress(null);
    }
  }, [allOrdersAddress]);

  useEffect(() => {
    if (orderSumary) {
      setRewardData((prev) =>
        prev !== orderSumary?.order_summary?.reward_status
          ? orderSumary?.order_summary?.reward_status
          : prev,
      );
      setCouponData((prev) =>
        prev !== orderSumary?.order_summary?.coupon
          ? orderSumary?.order_summary?.coupon
          : prev,
      );
      setSelectedIds((prev) =>
        prev !== orderSumary?.order_summary?.selected_id
          ? orderSumary?.order_summary?.selected_id
          : prev,
      );
    }
  }, [orderSumary]);

  const OrderCalculationData = async (
    coupon_id = null,
    rewardData,
    selectedIds,
    addressId = null,
  ) => {
    const data = {};
    if (coupon_id) {
      data.coupon_id = coupon_id;
    }
    if (selectedIds && selectedIds.length > 0) {
      data.selected_id = selectedIds;
    }
    if (rewardData) {
      data.reward_status = rewardData;
    }
    if (addressId) {
      data.address_id = addressId; 
    }
    return await dispatch(OrderCalculation(data));
  };

  
  useEffect(() => {
    OrderCalculationData(
      CouponData?.id,
      rewardData,
      selectedIds,
      selectedAddress,
    );
    // eslint-disable-next-line
  }, [rewardData, selectedIds, selectedAddress, allOrdersAddress]);

  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();
  const [error, setError] = useState("");
  const user = useSelector((state) => state.user.userInfo);

  const [razorpayKey, setRazorpayKey] = useState("");

  const fetchRazorpayKey = async () => {
    try {
      const res = await dispatch(getRazorpayKey());
      if (res.meta?.requestStatus === "fulfilled") {
        const p = res.payload;

        return p?.data?.key_id || p?.key_id || p?.data?.key || p?.key || "";
      }
    } catch (err) {
      console.error("Could not fetch Razorpay key", err);
    }
    return "";
  };

  useEffect(() => {
    let active = true;
    fetchRazorpayKey().then((key) => {
      if (active && key) setRazorpayKey(key);
    });
    return () => {
      active = false;
    };
    // eslint-disable-next-line
  }, []);

  // The order is created only after the payment succeeds.
  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(Number(price) * 100);

    let key = razorpayKey;
    if (!key) {
      setLoder(true);
      key = await fetchRazorpayKey();
      setLoder(false);
      if (key) setRazorpayKey(key);
    }

    if (!key) {
      setError("Payment is not available right now. Please try again later.");
      console.error("Razorpay key could not be loaded from the backend");
      return;
    }

    const options = {
      key: key,
      amount: amountInPaise,
      currency: "INR",
      name: "Bapat Optics",
      description: "Order Payment",

      handler: async function (res) {
        try {
          await finalFunction(res.razorpay_payment_id);
        } catch (err) {
          console.log(err);
          setLoder(false);
        }
      },

      modal: {
        ondismiss: function () {
          console.log("❌ Payment Popup Closed");
          setLoder(false);
        },
      },

      prefill: {
        name: user?.name,
        email: user?.email,
        contact: user?.contact_no,
      },

      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new window.Razorpay(options);
    rzpay.on("payment.failed", function (response) {
      console.log("❌ Payment Failed", response?.error);
      setLoder(false);
      setError(response?.error?.description || "Payment failed");
    });
    rzpay.open();
  };

  const isSignin = useSelector((state) => state.auth.is_signin);
  const [loder, setLoder] = useState("");

  // Called AFTER a successful Razorpay payment. Creates the order with the payment_id.
  // The server recalculates everything (including shipping) from address_id.
  const finalFunction = async (razorpay) => {
    setLoder(true);
    const datafinal = {
      address_id: selectedAddress,
      payment_method_id: paymentMethod,
      gst_number: GSTNumber,
      online: 1,
      order_summary: orderSumary?.order_summary,
      order_Details_summary: orderSumary?.order_Details_summary,
    };
    if (razorpay) {
      datafinal.payment_id = razorpay;
    }

    const res = await dispatch(createOrder(datafinal));

    if (res.meta?.requestStatus === "fulfilled") {
      setLoder(false);
      setSuccessmodal(true);
      await dispatch(getAllCart(isSignin));
      setTimeout(() => {
        setSuccessmodal(false);
        navigate("/");
      }, 1000);
    } else if (res.meta?.requestStatus === "rejected") {
      setLoder(false);
      if (res.payload?.errors) {
        setError(res.payload.errors);
      } else {
        setError(
          "We could not place your order. If money was deducted, it will be refunded automatically.",
        );
      }
    }
  };

  const [errorMessage, setErrorMessage] = useState("");
  const handleClick = async () => {
    if (!allOrdersAddress?.data || allOrdersAddress.data.length === 0) {
      setErrorMessage("Please add an address before proceeding to checkout.");
      return;
    }

    if (!termsAccepted) {
      setTermsError("Please accept the Terms & Conditions to continue.");
      return;
    }

    setError("");
    setErrorMessage("");
    setTermsError("");

    // recalculation calculation  (includes shipping),
    // so Razorpay is charged exactly the server total.
    setLoder(true);
    const calcRes = await OrderCalculationData(
      CouponData?.id,
      rewardData,
      selectedIds,
      selectedAddress,
    );
    setLoder(false);

    if (calcRes?.meta?.requestStatus !== "fulfilled") {
      setError("Could not calculate the order total. Please try again.");
      return;
    }

    const total = calcRes.payload?.data?.order_summary?.total_amount;
    handleRazorpay(parseFloat(total));
  };

  const DeleteAdrress = async (id) => {
    const res = await dispatch(deleteAddress({ id: id }));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllOrderAddress());

      setDeletemodal(true);
      setTimeout(() => {
        setDeletemodal(false);
      }, 2000);
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const PaymentOnlineCreate = async (data) => {
    const res = await dispatch(
      PaymentOnline({
        id: data.order_id,
        payment_id: data.razorpay_payment_id,
      }),
    );

    if (res.meta?.requestStatus === "fulfilled") {
      setLoder(false);
      setSuccessmodal(true);
      await dispatch(getAllCart(isSignin));
      setTimeout(() => {
        setSuccessmodal(false);
        navigate("/");
      }, 1000);
    }
  };

  // Open a policy popup without navigating or toggling the checkbox
  const openPolicy = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    setPolicyModal(type);
  };

  return (
    <section className="Checkout">
      <div className="container-fluid ">
        <Common_Back_Header backNavigation="/cart" />
        <div className="row justify-content-center mt-3">
          <div className="col-xxl-9 col-lg-8">
            <div className="left_side_div">
              <div className="white_card_holder">
                <div className="top_holder">
                  <p className="card_title">Shipping Address</p>
                  <p
                    className="add_address_btn"
                    onClick={() => {
                      setShowAddressModal(true);
                    }}
                  >
                    Add Address
                  </p>
                </div>

                <div className="address_holder">
                  <div className="row">
                    {allOrdersAddress?.data?.map((item) => {
                      return (
                        <div className="col-xxl-4 col-md-6 " key={item?.id}>
                          <div
                            className={`address_card ${
                              selectedAddress === item?.id ? "active" : ""
                            }`}
                          >
                            <div className="top_div">
                              <Form.Check
                                type="radio"
                                label={item?.Address_Type?.name}
                                name="address"
                                onChange={() => setSelectedAddress(item?.id)}
                                checked={selectedAddress === item?.id}
                              />

                              <div className="icons_holder">
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  className="inner_icon"
                                  onClick={() => {
                                    setEditId(item?.id);
                                    setShowEditAddressModal(true);
                                  }}
                                />
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  onClick={() => {
                                    DeleteAdrress(item?.id);
                                  }}
                                  className="inner_icon"
                                />
                              </div>
                            </div>

                            <p className="address_text">
                              {item?.floor}, {item?.building}, {item?.direction}
                              ,{item?.street}
                              {item?.Users_Address_Detail?.City?.name} -{" "}
                              {item?.Users_Address_Detail?.Pincode?.name}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="white_card_holder">
                <p className="card_title">Online</p>

                <div className="address_holder">
                  <div className={`address_card ${2 ? "active" : ""}`}>
                    <div className="option_holder">
                      <Form.Check
                        type="radio"
                        label=""
                        name="wallet"
                        onChange={() => setPaymentMethod(2)}
                        checked={paymentMethod === 2}
                      />
                      Online
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-8">
            {/* Reward Points row is hidden here (disable={true}); it is applied in the cart */}
            <Order_summery_holder
              disable={true}
              GSTNumber={GSTNumber}
              setGSTNumber={setGSTNumber}
              errorMessage={errorMessage}
              Checkout={true}
              address={allOrdersAddress?.data}
              error={error}
              rewardData={rewardData}
              setRewardData={setRewardData}
              btnText="Pay Now"
              handleClick={handleClick}
              orderSumary={orderSumary}
              footerContent={
                <div className="terms_consent">
                  <Form.Check
                    type="checkbox"
                    id="terms_checkbox"
                    checked={termsAccepted}
                    onChange={(e) => {
                      setTermsAccepted(e.target.checked);
                      if (e.target.checked) setTermsError("");
                    }}
                    label={
                      <>
                        I agree to the{" "}
                        <a
                          href="/terms-conditions"
                          onClick={(e) => openPolicy(e, "terms")}
                        >
                          Terms &amp; Conditions
                        </a>{" "}
                        and{" "}
                        <a
                          href="/privacy"
                          onClick={(e) => openPolicy(e, "privacy")}
                        >
                          Privacy Policy
                        </a>
                      </>
                    }
                  />
                  {termsError && <p className="terms_error">{termsError}</p>}
                </div>
              }
            />
          </div>
        </div>
      </div>
      {loder && (
        <div className="loader_holder">
          <div className="spinner"></div>
        </div>
      )}

      <New_Address_Modal
        setErrorMessage={setErrorMessage}
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
      />

      <Success_Modal
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"Order Purchase Succesfully"}
      />

      <Edit_Address_Modal
        Id={editId}
        show={showEditAddressModal}
        onHide={() => setShowEditAddressModal(false)}
      />
      <Success_Modal
        show={deleteModal}
        onHide={() => setDeletemodal(false)}
        successText={"Address Delete Succcessfully !"}
      />

      <Logout_Modal
        show={showLogoutModal}
        onHide={() => setshowLogoutModal(false)}
        questionText="Are you sure you want to delete this address?"
      />

      {/* Terms & Privacy popups */}
      <Policy_Modal
        show={policyModal === "terms"}
        onHide={() => setPolicyModal(null)}
        title="Terms & Conditions"
      >
        <Terms_Conditions />
      </Policy_Modal>

      <Policy_Modal
        show={policyModal === "privacy"}
        onHide={() => setPolicyModal(null)}
        title="Privacy Policy"
      >
        <Privacy_Policy />
      </Policy_Modal>
    </section>
  );
};

export default Checkout;